import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from '../../services/service-jsonrpc';
import { Observable, of, BehaviorSubject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AtylService {

  dossier:any = new BehaviorSubject("");

  constructor(
    private http: HttpClient
  ) {}
  
  /*STATES*/
  updateDossier(dossier:any) {
    this.dossier.next(dossier);
  } 
  /**/

  getForm(_typeForm: any, _dossierid ?: string): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.formulaire:new",
        params: {
          type: _typeForm,
          options: {
          }
        }
    });
    if(_dossierid)
      rpcMethod.params.options.dossier = _dossierid;

    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getFormulaire(_type: string, parent?: any, instructionid ?: any): Observable<any> {

      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.formulaire:new",
        params: {
          type: _type,
          options: {
            parent: parent
          }
        }

    });

    if(instructionid)
      rpcMethod.params.options.instruction = instructionid;

    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getFormulaireByID(formulaireID: any, formType ?: any, hide_readonly?: boolean): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.formulaire:get",
      params: {
        id: formulaireID,
        options: {
          type: formType,
          childView : true,
          hide_readonly: hide_readonly
        }
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  setNewFormulaire(_type: string, _fields:any,  instructionid?: any, parentid?: any, etat ?: any, favorable ?: any): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.formulaire:set",
        params: {
          type: _type,
          id: 0,
          options: {
            fields: _fields,
            etat: etat ? Number(etat) : 0,
            favorable : favorable ? Number(favorable) : 0
          }
        }
    });
    if(instructionid)
      rpcMethod.params.options.instruction = instructionid;
    if(parentid)
      rpcMethod.params.options.parent = parentid;
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  setFormulaire(form: any, instruction: any, demandeformulaireid ?: any, etat ?: any, parent ?: any, favorable ?: any,historic?: any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.formulaire:set",
      params: {
        type: form.key,
        id: demandeformulaireid ? demandeformulaireid : 0,
        options: {
          fields : form.fields,
          instruction: instruction.ID,
          demande: instruction.demande.ID,
          etat: etat ? Number(etat) : 0,
          favorable : favorable ? Number(favorable) : 0,
		  historic: historic
        }
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getList(_id: string,_options: any): Observable<any> {
      let rpcMethod = new JSONRpc({
          jsonrpc : "2.0",
          method:"webservice.liste:get",
          params: {
        id: _id,
        options :_options
          }
      })
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getListeSelection(_id: string, search: string, _options: any = [],demande:any=undefined): Observable<any> {
    let no_data:boolean=false;
	if (_options.no_data!=undefined) {
		no_data=_options.no_data;
	}
	
	let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.selection:get",
        params: {
            id: _id,
            options:
                {
                    	demande: demande,
					nodata:	no_data,
					filters : {
                        search : {
                            value : search
                        }
                    },
           			others:_options
                }
            
        }
    })
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
   getListeOptionsSelection(_id: string, options: any = []): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.selection:get",
       params: {
				id: _id,
				options: options
		}
            
        
    })
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  

  getListeTierSelection(search: string): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.tiers:list",
        params: {
            "types": ["MAM"],
            options:
                {
                  search : search
                }
        }
    })
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getTierByID(id: string): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.tiers:searchbyid",
        params: {
            id: id
        }
    })
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  getVilles(ville:string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:villes",
        params: {
          ville: ville.toUpperCase()
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getCodePostal(zip:string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:codepostal",
        params: {
          zip:zip
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getVillesByCP(zip: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:villebycp",
        params: {
          zip: zip
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getRues(rue: string, villeid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:rues",
        params: {
          libelle: rue.toUpperCase(),
          villeid: villeid
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getRueByVille(villeid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:ruebyville",
        params: {
          villeid: String(villeid)
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getZone(villeid: string, numrue: string, rueid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:zones",
        params: {
          villeid: villeid,
          options: {
            "numero" : numrue,
            "rueid": rueid
          }
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  printFormulaire(id: any, nonull?: boolean,wide?: boolean): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.impression:print",
        params: {
          id: id,
          options: {
          }
        }
      }
    )
    if(nonull)
      rpcMethod.params.options.nonull = nonull;
	  if(wide)
      rpcMethod.params.options.wide = wide;

    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getRelationByDossier(id:any, typeRelation: any): Observable<any>{
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.dossier:relations",
        params: {
          id: id,
          options: {
            relations: typeRelation
          }
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
   getGeoType(): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:geotype",
        params: {
          
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
  getGeo(type:string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc : "2.0",
        method:"webservice.adresse:geo",
        params: {
          type: type
        }
      }
    )
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
  getAllZones(): Observable<any> {

      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.parametre:zones",
        params: {
          
          options: {
            type:true
          }
        }

    });

   
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
    getZonesById(ids:any[], options: any = []): Observable<any> {

      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.adresse:zonesbyid",
        params: {
          ids: ids,
          options: options
        }

    });

   
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
  
}